import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clientService } from "../../../services";
import { Col } from "reactstrap";

import backgroundImage from "../../../assets/images/backgroundImage.png"; // Update with your background image path
import successIcon from "../../../assets/images/successIcon.png";
import errorIcon from "../../../assets/images/errorIcon.png"; // Update with your error message image path
import TempBanner from "../../GodoForm/TempBanner";

import "./EmailVerification.css"; // Assuming you have a CSS file for styling
import "../../GodoForm/GodoForm.css";

const EmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const [responseMessage, setResponseMessage] = useState({
    showBtn: true,
    message: "",
  });

  const { search, pathname } = useLocation();

  const hasRun = useRef(false); // Ref to ensure handleUpdate only runs once

  // Function to validate if the URL path and token query are correct
  const isValidPath = () => {
    const publicPath = process.env.PUBLIC_URL || "";
    const normalizedPublicPath =
      publicPath && publicPath !== "/" ? publicPath.replace(/\/$/, "") : "";
    const emailVerifiedPath = `${normalizedPublicPath}/emailVerified`;
    const isEmailVerifiedPath =
      pathname === emailVerifiedPath ||
      pathname.startsWith(`${emailVerifiedPath}/`);
    const hasToken = search.includes("?token=");
    return isEmailVerifiedPath && hasToken;
  };

  useEffect(() => {
    if (isValidPath() && !hasRun.current) {
      hasRun.current = true; // Mark as run
      handleUpdate();
    }
  }, [search]);


  const handleUpdate = async () => {
    setIsLoading(true);
    setError(null); // Reset error

    try {
      let postClient;

      // Example of the clientService call to update client details
      postClient = await clientService.updateLeadInfo(
        search.split("?token=")[1]
      );

      // If message indicates the link is expired, handle accordingly
      if (postClient?.status === 202) {
        setIsLinkExpired(true);
        setResponseMessage({
          showBtn: false,
          message: postClient?.data?.message,
        });
      } else if (postClient?.status === 201) {
        setIsLinkExpired(true);
        setResponseMessage({
          showBtn: false,
          message: postClient?.data?.message,
        });
      } else {
        setIsLinkExpired(false);
        setResponseMessage({
          showBtn: true,
          message: postClient?.data?.message,
        });
      }
    } catch (err) {
      console.error("Error during verification:", err);
      setError(
        "There was an error verifying your email. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // If the URL path is not valid, show "Page Not Found"
  if (!isValidPath()) {
    return (
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`, // Update with your background image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="sideContentWrapper">
          <Col md={6}>
            <h2 style={{ color: "red" }}>Page Not Found</h2>
            <p>
              The page you are looking for does not exist or the link is
              invalid.
            </p>
          </Col>
          {/* RIGHT STICKY IMAGE COLUMN */}
          <Col md={6} className="position-relative p-0 d-none d-sm-block">
            <div className="sideImageWrapper">
              <TempBanner />
            </div>
          </Col>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`, // Update with your background image path
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="sideContentSuccessWrapper">
        <Col md={6} className="sideContinerHeight">
          {/* Logo at the top */}
          <div className="logoImage">
            <a href="https://nafdak.eu/" target="_blank" rel="noopener noreferrer">
              <img
                src={`${process.env.PUBLIC_URL}/nafdaq-logo.jpg`}
                alt="Company Logo"
              />
            </a>
          </div>

          {isLoading ? (
            <div className="responseMessage" style={{ fontSize: "16px", marginTop: '30px', color: "#555", height: "400px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <div className="loader"></div> {/* The loader */}
            </div>
          ) : error ? (
            <div className="responseMessage" style={{ fontSize: "16px", marginTop: '30px', color: "red", height: "400px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <img src={errorIcon} alt="errorIcon" width={"80px"} />
              <p>{error}</p>
            </div>
          ) : isLinkExpired ? (
            <div className="responseMessage" style={{ textAlign: "center", marginTop: '30px', height: "400px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
              <p style={{ fontSize: "16px", color: "red" }}>
                {responseMessage.message}
              </p>
            </div>
          ) : (
            <div
              className="responseMessage"
              style={{
                fontSize: "16px",
                color: "#555",
                textAlign: "center",
              }}
            >
              <img src={successIcon} alt="succcessIcon" width={"80px"} />
              <p className="mt-5">{responseMessage.message}</p>
            </div>
          )}

          {/* Conditionally render the Login Button or Expired message */}
          {!isLinkExpired &&
            !isLoading &&
            !error &&
            responseMessage.showBtn && (
              <div className="portalButton" style={{ textAlign: "center" }}>
                <a
                  href="https://login.nafdak.godocm.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#094D96",
                    color: "#fff",
                    textDecoration: "none",
                    borderRadius: "6px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Login to Client Portal
                </a>
              </div>
            )}
        </Col>
        {/* RIGHT STICKY IMAGE COLUMN */}
        <Col md={6} className="position-relative p-0 d-none d-sm-block">
          <div className="sideImageWrapper">
            <TempBanner />
          </div>
        </Col>
      </div>
    </div>
  );
};

export default EmailVerification;
